const routes = {
  root: '/nativeRedirect',
}

export default routes
